export const SIDE_MENU_WIDTH_SMALL = 228;
export const SIDE_MENU_WIDTH_LARGE = 228;
export const SIDE_MENU_WIDTH_COLLAPSED = 112;
export const BOTTOM_BAR_HEIGHT = 72;

export const MENU_ITEM_ID = {
  CRYPTO_WAITLIST: 'cryptoWaitlist',
  CRYPTO_WAITLIST_EN: 'cryptoWaitlistEn',
};
